module.exports = __webpack_public_path__ + "static/media/banner_8.fd48fbd1.jpg";